import validateInvoicingAccess from "@/middleware/validateInvoicingAccess";

export default {
  name: "Invoicing",
  path: "/invoicing",
  component: () => import("@/views/Invoicing"),
  props: true,
  meta: {
    middleware: [validateInvoicingAccess]
  }
};
